export default __webpack_public_path__ + "static/media/Simulation-Centre.80c96378.jpg";